import { IconButton, Typography } from '@material-ui/core';
import { KeyboardArrowLeft, KeyboardArrowRight } from '@material-ui/icons';
import { getMonth, getYear } from 'date-fns';
import { months, MonthsTranslated, yearsOptions } from './DateRangePicker.utils';

interface DatePickerCustomHeaderProps {
  date: Date;
  changeYear(year: number): void;
  changeMonth(month: number): void;
  decreaseMonth(): void;
  increaseMonth(): void;
  //
  monthAndYearSelect: boolean;
}

export const DatePickerCustomHeader: React.FC<DatePickerCustomHeaderProps> = ({
  date,
  changeYear,
  changeMonth,
  decreaseMonth,
  increaseMonth,
  monthAndYearSelect = false,
}) => {
  return (
    <div className="flex justify-between items-center mx-4">
      <IconButton className="p-1" color="primary" onClick={decreaseMonth}>
        <KeyboardArrowLeft />
      </IconButton>

      <div className="flex justify-center space-x-1 items-center">
        {monthAndYearSelect ? (
          <>
            <select
              className="rounded-md border-2 border-primaryColor cursor-pointer outline-none"
              style={{ fontSize: 14.5 }}
              value={months[getMonth(date)]}
              onChange={({ target: { value } }) => changeMonth(months.indexOf(value as (typeof months)[number]))}
            >
              {months.map((month) => (
                <option style={{ fontSize: 14.5 }} key={month} value={month}>
                  {MonthsTranslated[month]}
                </option>
              ))}
            </select>

            <select
              className="rounded-md border-2 border-primaryColor cursor-pointer outline-none"
              style={{ fontSize: 14.5 }}
              value={getYear(date)}
              onChange={({ target: { value } }) => changeYear(Number(value))}
            >
              {yearsOptions.map((year) => (
                <option style={{ fontSize: 14.5 }} key={year} value={year}>
                  {year}
                </option>
              ))}
            </select>
          </>
        ) : (
          <>
            <Typography>{MonthsTranslated[months[getMonth(date)]]}</Typography>
            <Typography>{getYear(date)}</Typography>
          </>
        )}
      </div>

      <IconButton className="p-1" color="primary" onClick={increaseMonth}>
        <KeyboardArrowRight />
      </IconButton>
    </div>
  );
};
